import { useState,useEffect,useRef } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  TextField,
  List as MUIList,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  Box,
  Button,
  Snackbar,
  Alert
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import CloseIcon from '@mui/icons-material/Close';
import SaveIcon from '@mui/icons-material/Save';
import WatchlistAdd from '@mui/icons-material/PlaylistAdd';
import { List,AutoSizer } from 'react-virtualized';
import 'react-virtualized/styles.css'; // Import the styles for the List component
import { SNACKBAR_AUTO_HIDE_DURATION, TEXT_MSGS } from '../../common/utility/constant';
import { WATCHLIST_INSTRUMENT_ALLOWED } from '../../common/utility/mp_chart_constants';



export default function WatchlistSymbolModal({name, open, onClose,instrumentList,selectedWatchListInstrument,onCancel }) {
  const [watchlist, setWatchlist] = useState(selectedWatchListInstrument);
  const [search, setSearch] = useState("");
  const tableHeight=window.innerHeight*0.9-120;
  const inputRef = useRef(null);
  const [isDirty,setIsDirty]=useState(false);
  const syncInProgressRef = useRef(false);
  
  
  const [msgState, setMsgState] = useState({
    openSnack: false,
    msg: '',
    severity: 'info',
  })
  const { openSnack, msg, severity } = msgState

  useEffect(() => {
    if (open) {
      syncInProgressRef.current = true;
      setWatchlist(selectedWatchListInstrument || []);
      setSearch("");
      setIsDirty(false);
      const timer = setTimeout(() => {
        inputRef.current?.focus();
        syncInProgressRef.current = false;
      }, 100); // Wait a bit to ensure the TextField is mounted
      return () => clearTimeout(timer);
    }
  }, [open]);


  const handleClose = (event, reason) => {
    setMsgState({ ...msgState, openSnack: false })
  }

  const handleAdd = (instr) => {
    setWatchlist((prev) => (prev.includes(instr) ? prev : [...prev, instr]));
  };

  useEffect(()=>{
    if (syncInProgressRef.current) return;
    onClose(watchlist,name);
  },[watchlist])

  const handleRemove = (instr) => {
    setWatchlist((prev) => prev.filter((item) => item !== instr));
  };

  const filteredList = instrumentList.filter(item =>
    item.name.toLowerCase().includes(search.toLowerCase())
  );

  const handleSave=()=>{
    console.log("Symbol modal handleclose=",watchlist,name)
    onClose(watchlist,name)
  }

  const handleCancel=()=>{
    onCancel();
  }

  const handleToggleInstrument = (instr) => {
    const isInWatchlist = watchlist.includes(instr);

    if (isInWatchlist) {
      setIsDirty(true);
      handleRemove(instr);
      return;
    }

    if (watchlist.length >= WATCHLIST_INSTRUMENT_ALLOWED) {
      setMsgState({
        openSnack: true,
        msg: `${WATCHLIST_INSTRUMENT_ALLOWED}${TEXT_MSGS.MAXIMUM_ALLOWED_INSTRUMENT_IN_WATCHLIST}`,
        severity: 'info',
      });
      return;
    }

    setIsDirty(true);
    handleAdd(instr);
  };

  const rowRenderer = ({ key, index, style }) => {
    const item = filteredList[index];
    const isInWatchlist = watchlist.includes(item.instr);
  
    return (
      <div key={key} style={{ ...style, listStyle: 'none' }}>
        <ListItem
          component="div"
          button
          onClick={() => handleToggleInstrument(item.instr)}
          divider
          sx={{
            py: 0.5,
            minHeight: 36,
            // '& .MuiListItemText-primary': { fontSize: 14 },
            // '& .MuiListItemText-secondary': { fontSize: 12, color: 'gray' },
          }}
        >
          <ListItemText
            disableTypography
            primary={
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Box
                  sx={{
                    width: "80%",
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    fontSize: 14,
                    fontWeight: 500,
                  }}
                >
                  {item.name}
                </Box>
                {/* <Box
                  sx={{
                    width: 300,
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    fontSize: 12,
                    color: 'white',
                  }}
                >
                  {item.instr}
                </Box> */}
              </Box>
            }
          />
          <ListItemSecondaryAction>
            <IconButton
              onClick={(e) => {
                e.stopPropagation();
                handleToggleInstrument(item.instr);
              }}
              size="small"
            >
              {isInWatchlist ? <DeleteIcon fontSize="small" /> : <AddIcon fontSize="small" />}
            </IconButton>
          </ListItemSecondaryAction>
        </ListItem>
      </div>
    );
  };
  

  return (
    <Dialog
      open={open}
      onClose={()=>handleCancel()}
      PaperProps={{
        sx: {
          width: "60%",
          height: "90%",
          borderRadius: 2,
          p: 0,
        },
      }}
    >
      <DialogTitle
        sx={{
          fontSize: 18,
          fontWeight: 600,
          px: 2,
          py: 1.5,
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'nowrap' }}>
    <Box>Add Symbol</Box>

   <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      {/* // <Button
      //   variant="contained"
      //   color="primary"
      //   size="small"
      //   endIcon={<SaveIcon />}
      //   onClick={() => {
      //     console.log('Saving watchlist:', watchlist, name);
      //     // onClose(watchlist, name);
      //     handleSave()
      //   }}
      // >
      //   Save
      // </Button> */}

      <IconButton onClick={()=>handleCancel()}>
        <CloseIcon fontSize="small" />
      </IconButton>
    </Box> 
  </Box>
        
       
   
        {/* <IconButton onClick={()=>handleClose()} sx={{ position: 'absolute', right: 8, top: 8 }}>
          <CloseIcon fontSize="small" />
        </IconButton> */}
      </DialogTitle>

      <DialogContent sx={{ px: 2, py: 1 }}>
        <TextField
        inputRef={inputRef}
          placeholder="Search"
          size="small"
          fullWidth
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          sx={{ mb: 1 }}
        />

        <Box sx={{ maxHeight: "90%", overflowY: 'auto' }}>
          {filteredList.length === 0 ? (
            <Box sx={{ py: 2 }}>
              <Alert severity="info">No instruments match your search.</Alert>
            </Box>
          ) : (
            <Box sx={{ height: tableHeight }}>
              <AutoSizer>
                {({ height, width }) => (
                  <List
                    width={width}
                    height={height}
                    rowCount={filteredList.length}
                    rowHeight={48}
                    rowRenderer={rowRenderer}
                  />
                )}
              </AutoSizer>
            </Box>
          )}
        </Box>
        
      </DialogContent>
      <Snackbar
        onClose={handleClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={openSnack}
        autoHideDuration={SNACKBAR_AUTO_HIDE_DURATION}
        sx={{zIndex:99999}}
      >
        <Alert
          severity={severity}
          sx={{ width: { mobile: '80%', tablet: '70%', laptop: '40%' } }}
        >
          {msg}
        </Alert>
      </Snackbar>
      
    </Dialog>
  );
}
